// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"95":"efb45e85","146":"2d1dfeac","153":"5580cc2f","157":"52e18d94","187":"be123824","203":"efb49618","285":"19ffb1d2","386":"3196965a","453":"ea025e36","556":"43597497","746":"5c15381e","779":"7911e7a9"}[chunkId] + ".chunk.js";
};